import {Region} from "./Region";

export class CustomerAddress {


    city: string
    company: string
    country_id: string
    customerId: number
    defaultBilling: boolean
    defaultShipping: boolean
    firstname: string
    id: number = -1
    lastname: string
    postcode: string = "00000";
    region: Region
    regionId: number
    street: [any]
    telephone: string
    regionCode: string

}